import ReactCardFlip from "react-card-flip";
import React, { useState } from "react";
import "./fundselect.scss";
import Buttons from "../../atoms/Buttons";
import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import { Icons } from "../../atoms/Icons";
import cmsConfig from "../../redux/helpers/cmsConfig";

const FundSelect = (props) => {
  const [isFlipped, setIsFlipped] = useState({});

  const [cardsData] = useState(
    props.data?.filter((item) => item?.fundType === props.category),
  );
  const fundHandleClick = (cardId) => {
    setIsFlipped((prevState) => ({
      ...prevState,
      [cardId]: !prevState[cardId],
    }));
  };

  const handleCheckboxChange = (cardId) => {
    props.onCardSelect(cardId);
  };

  const openPopup = (url) => {
    const width = 1200;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    const popup = window.open(
      cmsConfig.baseUrl + url,
      "PopupWIndow",
      `width=${width},height=${height},left=${left},top=${top}`,
    );
    if (popup) {
      popup.focus();
    } else {
      alert("Popup blocked! Please allow popups for this site.");
    }
  };

  const managedForMeTooltip = (
    <Popover id="fs-pop-id" className="fs-popover-inner">
      <Popover.Body className="fs-popover-body">
        <div className="title mb-2">
          <strong>Managed for me</strong>
        </div>
        <div className="sub-title mb-2">
          A range of ready-made investment options designed and managed for you
          by TPT.
        </div>
        <div className="sub-title mb-3">
          This includes the Target Date Funds which would manage your investment
          during your savings period and for up to 30 years beyond the target
          date.
        </div>
        <div className="sub-title mb-3">
          Please review your choice of investments from time to time so that
          they continue to meet your needs and risk appetite.
        </div>
      </Popover.Body>
    </Popover>
  );
  const selfManagedTooltip = (
    <Popover id="fs-pop-id" className="fs-popover-inner">
      <Popover.Body className="fs-popover-body">
        <div className="title mb-2">
          <strong>Self-managed</strong>
        </div>
        <div className="sub-title mb-2">
          A range of investment options that you mix and match yourself.
        </div>
        <div className="sub-title mb-3">
          If you decide that you’d like your savings to grow faster, for
          example, we have funds that expose your money to slightly higher
          levels of risk for a potentially higher return. Or, there are ways to
          invest your pension savings in only ethical funds.
        </div>
        <div className="sub-title mb-3">
          Please review your choice of self-managed funds on a regular basis so
          that they continue to meet your needs and risk appetite.
        </div>
      </Popover.Body>
    </Popover>
  );

  const riskRatingToolTip = (investmentId) => {
    return (
      <Popover id={`pop-id-${investmentId}`} className="eac-popover-inner">
        <Popover.Body className="eac-popover-body">
          <div className="sub-title mb-2">
            It measures the relative risk and reward of an investment fund,
            where 1 being low risk and potentially low returns up to 7 high risk
            and potentially high returns.
          </div>
          <div className="sub-title mb-3">
            It’s calculated using past performance and volatility. This risk
            rating is a ‘Synthetic Risk and Reward Indicator’ (SRRI). The SRRI
            risk ratings are based on European Security and Markets Authority
            (ESMA) guidelines.
          </div>
          <div className="sub-title mb-3">
            The risk rating doesn’t guarantee how the fund will perform in the
            future, and it can change over time.
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const esgRatingToolTip = (investmentId) => {
    return (
      <Popover id={`pop-id-${investmentId}`} className="eac-popover-inner">
        <Popover.Body className="eac-popover-body">
          <div className="sub-title mb-2">
            The MSCI ESG Fund Rating is designed to measure the Environmental,
            Social and Governance (ESG) characteristics of a fund’s underlying
            investment holdings.
          </div>
          <div className="sub-title mb-3">
            The ESG Rating ranges from leader (AAA, AA), average (A, BBB, BB) to
            laggard (B, CCC).
          </div>
          <div className="sub-title mb-3">
            The overall fund score is based on each individual holding’s ESG
            rating and the proportion held in this fund (and if there is
            sufficient available data to do so).
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  return (
    <div className="fs-horizontal-cards-container">
      {cardsData?.length !== 0 ? (
        <div className="fs-managed-income-heading">
          <span className="fs-manage-heading-text">
            {props.category}{" "}
            <OverlayTrigger
              placement="bottom"
              overlay={
                props.category === "Self-managed"
                  ? selfManagedTooltip
                  : managedForMeTooltip
              }
              flip={true}
            >
              <span className="fs-manage-heading-icon-margin">
                <Icons iconname="tool-tip" variant="icon-sixteen-px" />
              </span>
            </OverlayTrigger>
          </span>
        </div>
      ) : (
        ""
      )}
      {cardsData?.map((card) => (
        <ReactCardFlip
          key={card.investmentId}
          isFlipped={isFlipped[card.investmentId] || false}
          flipDirection="horizontal"
        >
          <div
            className="fs-investment-card"
            key={`front-${card.investmentId}`}
          >
            <CustomCheckbox
              name={`enc-${card.investmentId}`}
              defaultChecked={card.checked}
              variantName="custom-checkbox fs-checkbox-align"
              type="checkbox"
              onChange={() => handleCheckboxChange(card.investmentId)}
            />
            <div className="fs-card-front">
              <Row className="fs-card-front-title me-1">
                <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                  <div
                    className="fs-circle"
                    style={{ backgroundColor: card.color }}
                  ></div>
                </Col>
                <Col
                  xl={10}
                  lg={10}
                  md={10}
                  sm={10}
                  xs={10}
                  className="fs-fund-name"
                >
                  {card.fundName}
                </Col>
              </Row>
              <div className="fs-fund-text">{card.desc}</div>
              <div className="fs-button-align d-none d-xl-block d-lg-block d-md-block">
                <div className="fs-view-fund-button">
                  <Buttons
                    name="View full fund fact sheet"
                    className="tertiary"
                    handleClick={() => openPopup(card.pDFUrl)}
                  ></Buttons>
                </div>
                <Buttons
                  name="See overview"
                  className="secondary"
                  handleClick={() => fundHandleClick(card.investmentId)}
                ></Buttons>
              </div>
              <div className="d-block d-sm-none">
                <div className="fs-mobile-button-align">
                  <div className="fs-mobile-view-fund-button">
                    <Buttons
                      name="View fund fact sheet"
                      className="tertiary"
                      handleClick={() => openPopup(card.pDFUrl)}
                    ></Buttons>
                  </div>
                  <div className="fs-mobile-see-overview-button">
                    <Buttons
                      name="See overview"
                      className="secondary"
                      handleClick={() => fundHandleClick(card.investmentId)}
                    ></Buttons>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="fs-back-investment-card"
            key={`back-${card.investmentId}`}
          >
            <div className="fs-card-back">
              <Row className="fs-card-back-title">
                <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                  <div
                    className="fs-circle"
                    style={{ backgroundColor: card.color }}
                  ></div>
                </Col>
                <Col
                  xl={10}
                  lg={10}
                  md={10}
                  sm={10}
                  xs={10}
                  className="fs-fund-name"
                >
                  {card.fundName}
                </Col>
              </Row>
              <div>
                <Row className="fs-managed-by-text">
                  <Col>
                    <div className="fs-managed-parent-text">
                      <span className="fs-left-text">Managed by</span>
                      <span className="fs-right-text">{card.managedBy}</span>
                    </div>
                  </Col>
                </Row>
                <Row className="fs-managed-by-text">
                  <Col>
                    <div className="fs-managed-parent-text">
                      <span className="fs-left-text">Fund charge</span>
                      <span className="fs-right-text">{card.fundCharge}</span>
                    </div>
                  </Col>
                </Row>
                <Row className="fs-managed-by-text">
                  <Col>
                    <div className="fs-managed-parent-text">
                      <span className="fs-left-text">
                        Risk rating
                        <OverlayTrigger
                          placement="bottom"
                          overlay={riskRatingToolTip(card.investmentId)}
                          flip={true}
                        >
                          <span className="fs-risk-rating-icon-margin">
                            <Icons
                              iconname="tool-tip"
                              variant="icon-twelve-px"
                            />
                          </span>
                        </OverlayTrigger>
                      </span>
                      <span className="fs-right-text">{card.riskRating}</span>
                    </div>
                  </Col>
                </Row>
              </div>
              {card.ESGRating === "" ||
              card.ESGRating === " " ||
              card.ESGRating === null ? (
                <>
                  <div className="fs-Average-text-blank"></div>
                </>
              ) : (
                <>
                  <div className="fs-Average-text">
                    Average ESG Rating
                    <span
                      className="fs-risk-rating-icon-margin"
                      id={card.investmentId}
                    >
                      <OverlayTrigger
                        id={card.investmentId}
                        placement="bottom"
                        overlay={esgRatingToolTip(card.investmentId)}
                        flip={true}
                      >
                        <span>
                          <Icons
                            iconname="tool-tip"
                            variant="icon-sixteen-px"
                          />
                        </span>
                      </OverlayTrigger>
                    </span>
                  </div>
                  <div className="fs-parent-rating-box">
                    <span
                      className={
                        card.ESGRating === "CCC"
                          ? "fs-colored-rating-box"
                          : "fs-rating-box"
                      }
                    >
                      CCC
                    </span>
                    <span
                      className={
                        card.ESGRating === "B"
                          ? "fs-colored-rating-box"
                          : "fs-rating-box"
                      }
                    >
                      B
                    </span>
                    <span
                      className={
                        card.ESGRating === "BB"
                          ? "fs-colored-rating-box"
                          : "fs-rating-box"
                      }
                    >
                      BB
                    </span>
                    <span
                      className={
                        card.ESGRating === "BBB"
                          ? "fs-colored-rating-box"
                          : "fs-rating-box"
                      }
                    >
                      BBB
                    </span>
                    <span
                      className={
                        card.ESGRating === "A"
                          ? "fs-colored-rating-box"
                          : "fs-rating-box"
                      }
                    >
                      A
                    </span>
                    <span
                      className={
                        card.ESGRating === "AA"
                          ? "fs-colored-rating-box"
                          : "fs-rating-box"
                      }
                    >
                      AA
                    </span>
                    <span
                      className={
                        card.ESGRating === "AAA"
                          ? "fs-colored-rating-box"
                          : "fs-rating-box"
                      }
                    >
                      AAA
                    </span>
                  </div>
                </>
              )}
              <div className="fs-button-align d-none d-xl-block d-lg-block d-md-block">
                <div className="fs-view-fund-button">
                  <Buttons
                    name="View full fund fact sheet"
                    className="tertiary"
                    handleClick={() => openPopup(card.pDFUrl)}
                  ></Buttons>
                </div>
                <Buttons
                  name="Close overview"
                  className="secondary"
                  handleClick={() => fundHandleClick(card.investmentId)}
                ></Buttons>
              </div>
              <div className="d-block d-sm-none">
                <div className="fs-mobile-button-align">
                  <div className="fs-mobile-view-fund-button">
                    <Buttons
                      name="View fund fact sheet"
                      className="tertiary"
                      handleClick={() => openPopup(card.pDFUrl)}
                    ></Buttons>
                  </div>
                  <div className="fs-mobile-see-overview-button">
                    <Buttons
                      name="See overview"
                      className="secondary"
                      handleClick={() => fundHandleClick(card.investmentId)}
                    ></Buttons>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ReactCardFlip>
      ))}
    </div>
  );
};

export default FundSelect;
